// removed by extract-text-webpack-plugin
module.exports = {"primary":"#00B0EB","primaryLight":"#66D1F4","onPrimaryTextColor":"white","sidebar":"Style__sidebar___1S9r7","nav":"Style__nav___2vZm5","icon":"Style__icon___2A4YW","message-count":"Style__message-count___1BmvN","socialMediaIcons":"Style__socialMediaIcons___3OeFv","title":"Style__title___3tQ-A","icons":"Style__icons___3Mwy1"};


//////////////////
// WEBPACK FOOTER
// ./client/components/layout/Sidebar/Style.css
// module id = 2054
// module chunks = 0